/*
 * @Author: xiashui 
 * @Date: 2020-08-27 18:23:09 
 * @Last Modified by: xiashui
 * @Last Modified time: 2020-09-01 15:03:09
 */
// 获取当前时间时间戳
function getTime() {
    return new Date().getTime();
};

// 获取当前路由
function getRoute() {
    return window.location.href;
};

// 获取储存内容
function getStorage(key) {
    return window.localStorage.getItem(key);
};

// 储存内容
function setStorage(key, value) {
    return window.localStorage.setItem(key, value);
};




export {
    getTime,
    getRoute,
    getStorage,
    setStorage
};



// WEBPACK FOOTER //
// ./src/assets/plugin/track/pathStat/utils.js